export default {
  tariff: 'Pricing',
  acceptedAt: 'Pricing acceptance date',
  activatedAt: 'Activation date',
  updateTariff: 'Update tariff',
  downloadTariff: 'Download tariff',
  activeTariffFileName: '{{tenantId}}_{{tariffName}}_{{date}}_active.xlsx',
  updateScheduled: 'Planned pricing plan changes from {{date}}',
  showUpdate: 'Show changes',
};
